export const updateShareId = (newShareId) => {
  const url = new URL(window.location.href);
  if (url.searchParams.has('share_id')) {
    url.searchParams.set('share_id', newShareId);
    window.history.pushState({}, '', url);
  }
};
